import { CouponObject } from '../controllers/SubscriptionsController';
import CouponModel from '../model/CouponModel';

export const getPlanPrice = (
  price: number,
  coupon?: CouponObject | CouponModel,
) => {
  if (
    coupon === undefined ||
    coupon.discount === null ||
    coupon.discount === undefined
  ) {
    return price;
  }
  const amount =
    coupon.discount.type === 'dollars'
      ? coupon.discount.value * 100
      : (price * coupon.discount.value) / 100;
  return Math.max(0, price - amount);
};
